// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2zjWY","header":"ClearentDisclaimer_header__tYGp_","inner":"ClearentDisclaimer_inner__2Q2xa"};